import { Badge } from '@/components/ui/badge';
import { useAuth } from '@/hooks/useAuth';
import { Database, Eye } from 'lucide-react';

/**
 * ModeIndicator - Shows current authentication mode
 */
export const ModeIndicator = () => {
  const { isDemoMode, isPreviewMode } = useAuth();

  if (!isDemoMode && !isPreviewMode) {
    return null; // Normal production mode, no indicator needed
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      {isPreviewMode && (
        <Badge variant="default" className="bg-green-600 hover:bg-green-700 text-white">
          <Database className="w-3 h-3 mr-1" />
          Enhanced Preview (Real Data)
        </Badge>
      )}
      {isDemoMode && !isPreviewMode && (
        <Badge variant="secondary" className="bg-blue-600 hover:bg-blue-700 text-white">
          <Eye className="w-3 h-3 mr-1" />
          Demo Mode (Mock Data)
        </Badge>
      )}
    </div>
  );
};